import React, { ComponentProps, ComponentType, HTMLProps } from 'react';
import Field, { FieldProps } from '../Field';
import Combobox, { ComboboxProps } from '../../ui/primitives/Combobox';

// 'as' must be an instance, anonymous functions are recreated each render
const ComboboxField = ({ child: Component, suggestion, ...fieldProps }) => (
    <Component {...fieldProps} highlighted={fieldProps.value && suggestion === fieldProps.value} />
);

type AsComponentProps<T extends ComponentType> = Partial<ComboboxProps> & { as?: T } & Omit<
        ComponentProps<T>,
        keyof ComboboxProps
    >;
type AsInputProps = { as?: 'input' } & HTMLProps<HTMLInputElement>;

type FieldComboboxProps<T extends ComponentType> = Partial<ComboboxProps> & {
    name: string;
    fieldClassName?: string;
} & Omit<FieldProps<unknown>, 'as'> &
    (AsComponentProps<T> | AsInputProps);

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ComponentType<any> is used to allow any component
export default function FieldCombobox<T extends ComponentType<any>>({
    as,
    fieldClassName,
    name,
    ...props
}: FieldComboboxProps<T>) {
    const Component = as || Combobox;
    return <Field {...props} as={ComboboxField} child={Component} name={name} fieldClassName={fieldClassName} />;
}
